<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    การจัดการสมาชิก
                </div>


                <div class="row search-section">
                    <div class="col-sm-2 col-search">

                        <button type="button" class="btn bg-teal waves-effect btn-search" @click="add()">
                            <i class="material-icons">add_box</i>
                            <span>สร้างสมาชิก</span>
                        </button>

                    </div>
                    <div class="col-sm-5 col-search"></div>
                    <div class="col-sm-2 col-search">
                        <input type="text" class="search-textbox" v-model="key"
                            placeholder="กรุณากรอกชื่อสมาชิก เพื่อค้นหา" style="width:100%;margin-top:5px">
                    </div>

                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching"
                            @click="search(1)">
                            <i class="material-icons">search</i>
                            <span>ค้นหา</span>
                        </button>
                    </div>
                    <div class="col-sm-1 col-search">
                        <button type="button" class="btn bg-grey waves-effect btn-search" :disabled="searching"
                            @click="reset()">
                            <i class="material-icons">refresh</i>
                            <span>Reset</span>
                        </button>
                    </div>

                </div>
                <div class="row ">
                    <div class="col-sm-12 " style="text-align: right;">
                        <img src="static/images/excel.png" class="excel-icon" alt="download excel"
                            style="margin-right: 15px;cursor: pointer;" @click="download()" />
                    </div>
                </div>
                <div class="body table-responsive" style="width:100%">
                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="fn-th" style="width: 80px;">No.</th>
                                    <th class="fn-th">username</th>
                                    <th class="fn-th">ชื่อ-นามสกุล</th>
                                    <th class="fn-th">หมายเลขโทรศัพท์</th>
                                    <th class="fn-th">เครดิต</th>
                                    <th class="fn-th">ประเภท</th>
                                    <th class="fn-th">สถานะ</th>
                                    <th class="fn-th" style="width: 80px;">รายละเอียด</th>
                                    <th class="fn-th" style="width: 80px;">แก้ไขข้อมูล</th>
                                    <th class="fn-th" style="width: 80px;">แก้ไขเครดิต</th>
                                    <th class="fn-th" style="width: 80px;">ลบ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="'p-' + item.id"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                    <td v-html="((page-1) * perpage) + index + 1"></td>
                            
                                    <td style="text-align: center;">
                                        <span>{{ item.username }}</span>
                                    </td>

                                   

                                    <td style="text-align: center;">
                                        <span>{{ item.name }}</span>
                                    </td>

                                  

                                    <td style="text-align: center;">
                                        <span>{{ item.tel }}</span>
                                    </td>

                                 

                                    <td style="text-align: center;">
                                        <span>{{ item.credit ? item.credit : 0 }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.login_type }}</span>
                                    </td>

                                    <td style="text-align: center;">
                                        <span>{{ item.active == 1 ? 'Active' : 'Inactive' }}</span>
                                    </td>
                                   
                                    <td style="text-align: center;">
                                        <img src="static/images/view.png"  alt="view" @click="showDetail(item.id)"/>
                                         
                                    </td>
                                    <td>
                                        <span @click="edit(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon">mode_edit</i>
                                            </a>
                                        </span>
                                    </td>
                                    <td>
                                        <span @click="edit(item.id, true)">
                                            <a href="#">
                                                <i class="material-icons fn-icon">attach_money</i>
                                            </a>
                                        </span>
                                    </td>
                                    <td>
                                        <span @click="del(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon" style="color:red;">cancel</i>
                                            </a>
                                        </span>
                                    </td>

                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <Paginate v-model=page :page-count=pages :page-range="5" :click-handler="search" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'fn-pagination'" />


                </div>
            </div>
        </div>
        <div class="modal fade" id="member-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">สร้างสมาชิก</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>username:</span>
                        </div>
                        <div class="col-sm-8">
                           
                            <input type="text" class="form-control" v-model="member.username" placeholder="" :disabled="member.id > 0">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;" v-if="member.id > 0">
                        <div class="col-sm-2  col-label">
                        
                        </div>
                        <div class="col-sm-8 text-left">
                           
                            <input type="checkbox" id="checkbox-user" @click="setpassword = !setpassword" class="filled-in chk-col-indigo" :checked="setpassword"/>
                            <label for="checkbox-user" >ตั้งค่ารหัสผ่านใหม่</label>
                        </div>
                    </div>
                     <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>รหัสผ่าน:</span>
                        </div>
                        <div class="col-sm-8">
                           
                            <input type="password" class="form-control" v-model="member.password" placeholder=""  :disabled="!setpassword">
                        </div>
                    </div>
                     <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>ยืนยันรหัสผ่าน:</span>
                        </div>
                        <div class="col-sm-8">
                           
                            <input type="password" class="form-control" v-model="member.confirm_password" placeholder=""  :disabled="!setpassword">
                        </div>
                    </div>
                     <!-- <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>หมายเลขบัตรประชาชน:</span>
                        </div>
                        <div class="col-sm-8">
                           
                            <input type="text" class="form-control" v-model="member.id_card" placeholder="">
                        </div>
                    </div> -->
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>ชื่อ - นามสกุล:</span>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" v-model="member.name" placeholder="">
                        </div>
                       
                    </div>
                     
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>หมายเลขโทรศัพท์:</span>
                        </div>
                        <div class="col-sm-4">
                           
                            <input type="text" class="form-control" v-model="member.tel" placeholder="">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>อีเมล:</span>
                        </div>
                        <div class="col-sm-8">
                           
                            <input type="text" class="form-control" v-model="member.email" placeholder="">
                        </div>
                    </div>
                    
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>สถานะ:</span>
                        </div>
                        <div class="col-sm-4">
                            <select class="form-control  show-tick fn-required" v-model="member.active">
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                        </div>
                    </div>

                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;"
                        @click="handleSave()">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>

         <div class="modal fade" id="member-credit-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">แก้ไขเครดิต</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>username:</span>
                        </div>
                        <div class="col-sm-8">
                           
                            <input type="text" class="form-control" v-model="member.username" placeholder="" :disabled="member.id > 0">
                        </div>
                    </div>
             
         

                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>เครดิต:</span>
                        </div>
                        <div class="col-sm-4">
                           
                            <input type="text" class="form-control" v-model="member.credit" placeholder="">
                        </div>
                    </div>
                 

                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;"
                        @click="updateCredit()">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>

        <div class="modal fade" id="member-detail-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">รายละเอียดสมาชิก</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-4  col-label text-left">
                            <span>username:</span>
                        </div>
                        <div class="col-sm-8 text-left">
                           <span>{{ member.username }}</span>
                          
                        </div>
                    </div>
                 
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-4  col-label text-left">
                            <span>ชื่อ - นามสกุล:</span>
                        </div>
                        <div class="col-sm-8 text-left">
                            <span>{{ member.name }}</span>
                        </div>
                       
                    </div>
                    
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-4  col-label text-left">
                            <span>หมายเลขโทรศัพท์:</span>
                        </div>
                        <div class="col-sm-8 text-left">
                           
                            <span>{{ member.tel }}</span>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-4  col-label text-left">
                            <span>อีเมล:</span>
                        </div>
                        <div class="col-sm-8 text-left">
                           
                            <span>{{ member.email }}</span>
                        </div>
                    </div>

                     <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-4  col-label text-left">
                            <span>เครดิต:</span>
                        </div>
                        <div class="col-sm-8 text-left">
                           
                            <span>{{ member.credit }}</span>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-4  col-label text-left">
                            <span>ประเภท:</span>
                        </div>
                        <div class="col-sm-8 text-left">
                           
                            <span>{{ member.login_type }}</span>
                        </div>
                    </div>
                    
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-4 col-label text-left">
                            <span>สถานะ:</span>
                        </div>
                        <div class="col-sm-8 text-left">
                            <span>{{ member.active == 1 ? 'Active' : 'Inactive' }}</span>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 15px;margin-bottom: 15px;">
                        <div class="col-sm-4 col-label text-left">
                            <span>วันที่สมัคร:</span>
                        </div>
                        <div class="col-sm-8 text-left">
                            <span>{{ member.created_at | date }}</span>
                        </div>
                    </div>


                </div>
                 <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { MemberService } from '../../service'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import alertBox from '../../classes/alertBox'
import Paginate from 'vuejs-paginate'

export default {
    name: "MemberManage",
    components: {
        DatePicker,
        Paginate
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            page: 1,
            perpage: 50,
            total: 0,
            pages: 0,
            items: [],
            member: {
                member_id: 0,
                username: "",
                password: "",
                name: "",
                tel: "",
                email: "",
                active: "1",
                created_by: ""
            },
            setpassword: false,
            key: "",
            file: null,
            searching: false,
            loading: false,
            search_params: {}
        }
    },
    async created() {

        this.search(1)
    },
    mounted() {

    },
    methods: {

        async search(p = 0) {
             if (p > 0) {
                this.page = p
            }
            this.loading = true
            let response = await MemberService.search(this.key, this.page, this.perpage)
           
            if (response.status) {
                let { page, perpage, total, pages, data } = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages)
                this.items = data

            }
            this.loading = false
        },
        reset(p = 1) {
            this.key = ""
            this.search(p)
        },
        add() {
            this.setpassword = true
            this.member = {
                member_id: 0,
                username: "",
                password: "",
                gender: "",
                name: "",
                tel: "",
                email: "",
                active: "1",
                created_by: this.user.id
            }
            $('#member-modal').modal('show')
        },
        edit(id,credit = false) {
          
            let member = this.items.find(x => x.id == id)
            this.member = { ...member, updated_by: this.user.id }
            this.setpassword = false
           
            if(credit){
                $('#member-credit-modal').modal('show')
            }
            else{
                 $('#member-modal').modal('show')
            }
        },
        async handleSave() {
            if (!this.validate()) {
                return false
            }

            if (this.member.id == 0) {
                await this.create()
            }
            else {
                await this.update()
            }
        },
        validate() {
            if (!this.member.username) {
                alertBox.error("กรุณากรอกชื่อสมาชิก")
                return false
            }
            

            return true
        },
        checkPassword(){
                if(!this.member.password){
                    alertBox.error("กรุณากรอกรหัสผ่าน")
                    return false
                }
                if(!this.member.confirm_password){
                    alertBox.error("กรุณากรอกยืนยันรหัสผ่าน")
                    return false
                }
                if(this.member.password !== this.member.confirm_password){
                    alertBox.error("รหัสผ่านกับยืนยันรหัสผ่านไม่ตรงกัน")
                    return false
                }
                //if(this.member.password.length < 8){
                    //alertBox.error("กรุณากรอกรหัสผ่านไม่น้อยกว่า 8 ตัวอักษร")
                   // return false
                //}
                return true
           
        },
        async create() {
            try {
             
                if(!this.checkPassword()){
                    return false
                }

                let response = await MemberService.create(this.member)
             
                if (response.status) {
                    alertBox.success('save success')
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
                $('#member-modal').modal('hide')
            }
            catch (error) {
                alertBox.error("Error, " + error)
                $('#member-modal').modal('hide')
            }
        },
        async update() {
            try {
                let response = await MemberService.update(this.member)
               
                if (response.status) {
                    alertBox.success('save success')
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
                  $('#member-modal').modal('hide')
            }
            catch (error) {
                alertBox.error("Error, " + error)
                  $('#member-modal').modal('hide')
            }
        },
        async updateCredit() {
            try {
                let response = await MemberService.updateCredit(this.member.id, this.member.credit,this.user.id)
                
                if (response.status) {
                    alertBox.success('save success')
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
                  $('#member-credit-modal').modal('hide')
            }
            catch (error) {
                alertBox.error("Error, " + error)
                  $('#member-credit-modal').modal('hide')
            }
        },
        async del(id) {
            let result = await alertBox.confirm('คุณแน่ใจที่จะลบ?')
            if (result) {
                let data = {
                    member_id: id,
                    updated_by: this.user.id
                }
                let response = await MemberService.delete(data)

                if (response.status) {
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
        },
        showDetail(id) {
            let member = this.items.find(x => x.id == id)
            this.member = { ...member }
            $('#member-detail-modal').modal('show')
        },
         async searchRecord(id) {
            let response = await MemberService.getById(id)
            
            if (response.status) {
                let { data } = response.result
                this.member = { ...data }
                $('#member-detail-modal').modal('show')
            }
         },
         download() {
             window.open(`${process.env.VUE_APP_API_URL}/admin/member/download?searchKey=${this.key}`)
         }
        
    },
    filters: {
        comma(value) {
            return helper.WithComma(value)
        },
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>

<style scoped>
 .text-left {
    padding-left: 20px;
    text-align: left;
    padding-top: 5px;
 }
</style>


// WEBPACK FOOTER //
// src/components/Manage/Member.vue